import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`For your security, npm may require additional verification to allow you to log in to your account.  If you do not have `}<a parentName="p" {...{
        "href": "configuring-two-factor-authentication"
      }}>{`two-factor authentication`}</a>{` enabled, you may be asked to verify yourself with a one-time password sent to the email address configured for your account.`}</p>
    <h2>{`Logging in with a one-time password`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You'll be prompted for a one-time password that was sent to your email.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/one-time-password-email.png" alt="Screenshot showing one-time password request" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Check your email account for an email from npm containing your one-time password (the subject will begin "OTP for logging in to your account").`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/email-otp-code.png" alt="Screenshot showing OTP code in email" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter the digits from your email in your one-time password field.`}</p>
      </li>
    </ol>
    <h2>{`Enabling two-factor authentication`}</h2>
    <p>{`To avoid this additional login step, with a one-time password sent to you via e-mail, you can configure `}<a parentName="p" {...{
        "href": "/configuring-two-factor-authentication"
      }}>{`two-factor authentication with a device`}</a>{` (2FA) instead.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      